import { XCircle, CheckCircle2 } from "lucide-react";

const PROBLEMS = [
  "Falhas e retrabalho em peças fora de padrão",
  "Prazos imprevisíveis paralisando a operação",
  "Fornecedores sem integração entre processos",
];

const SOLUTIONS = [
  "Alto padrão técnico e responsabilidade operacional",
  "Previsibilidade de entrega e redução de falhas",
  "Padrão consistente de qualidade em cada projeto",
];

export default function SocialProof() {
  return (
    <section
      id="sobre"
      data-testid="social-proof-section"
      className="relative py-20 sm:py-28 bg-[var(--buzas-bg)]"
    >
      <div className="container-buzas">
        <div className="max-w-3xl mb-14">
          <span className="eyebrow">Prova social</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight text-[var(--buzas-navy)]">
            Com mais de 30 anos de atuação na indústria metalúrgica.
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[var(--buzas-muted)] leading-relaxed">
            A Buzas atende setores que exigem alto padrão técnico,
            confiabilidade e responsabilidade operacional. Nossa estrutura
            integrada reduz falhas, melhora a previsibilidade de entrega e
            garante padrão consistente de qualidade em cada projeto.
          </p>
        </div>

        {/* Problem / Solution cards */}
        <div className="grid lg:grid-cols-2 gap-6">
          {/* Problem */}
          <div
            data-testid="problem-card"
            className="rounded-xl bg-white border border-[var(--buzas-border)] p-8 sm:p-10"
          >
            <p className="eyebrow">O problema</p>
            <h3 className="mt-4 font-display text-2xl sm:text-[26px] font-bold text-[var(--buzas-navy)] leading-tight">
              Peças fora de padrão geram risco e custo na operação.
            </h3>
            <p className="mt-4 text-[15px] text-[var(--buzas-muted)] leading-relaxed">
              Sem controle dimensional e integração entre processos, a
              aeronave fica parada, o prazo aumenta e a confiança do cliente
              cai.
            </p>
            <ul className="mt-6 space-y-3">
              {PROBLEMS.map((p, i) => (
                <li
                  key={p}
                  data-testid={`problem-item-${i}`}
                  className="flex items-start gap-3 text-[15px] text-[var(--buzas-navy)]"
                >
                  <XCircle
                    size={20}
                    className="text-[var(--buzas-red)] shrink-0 mt-0.5"
                  />
                  <span className="font-semibold">{p}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Solution */}
          <div
            data-testid="solution-card"
            className="rounded-xl p-8 sm:p-10 text-white"
            style={{ background: "var(--buzas-navy)" }}
          >
            <p
              className="eyebrow"
              style={{ color: "#ff8a8a" }}
            >
              A solução Buzas
            </p>
            <h3 className="mt-4 font-display text-2xl sm:text-[26px] font-bold text-white leading-tight">
              Processos integrados, controle técnico e entrega previsível.
            </h3>
            <p className="mt-4 text-[15px] leading-relaxed text-white/80">
              Do corte a laser à montagem final, cada etapa acontece
              internamente, com inspeção dimensional para garantir padrão
              consistente em cada lote.
            </p>
            <ul className="mt-6 space-y-3">
              {SOLUTIONS.map((s, i) => (
                <li
                  key={s}
                  data-testid={`solution-item-${i}`}
                  className="flex items-start gap-3 text-[15px] text-white"
                >
                  <CheckCircle2
                    size={20}
                    className="text-[var(--buzas-red)] shrink-0 mt-0.5"
                  />
                  <span className="font-semibold">{s}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 pt-6 border-t border-white/15 flex items-baseline gap-3">
              <span className="font-display text-4xl font-black text-white">
                30+
              </span>
              <span className="text-sm text-white/80 leading-tight">
                anos de atuação na
                <br />
                indústria metalúrgica
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
